import { Invoice, ChargeState } from "@oysterhr/schema"
import { ClientInvoicePaymentState } from "../constants/invoices"
import { DateTime } from "luxon"

export const getClientInvoiceChargeState = ({
  chargeState,
  dueDate,
}: { chargeState: ChargeState } & Pick<Invoice, "dueDate">): ClientInvoicePaymentState => {
  if (chargeState === ChargeState.AutomatedProcessConfirmed) {
    return ChargeState.AutomatedProcessInProgress
  }
  if (
    chargeState === ChargeState.ManualProcessNotPaid &&
    DateTime.now() > DateTime.fromISO(dueDate).plus({ days: 7 })
  ) {
    return ChargeState.Overdue
  }

  return chargeState
}
